import Layout from "../../components/layout/Layout";
import Navbar from "../../components/layout/header/Navbar";
import Hero from "./Hero";
import WhyParticipate from "../../components/why-participate/WhyParticipate";
import WhyChooseUs from "../../components/why-choose-us/WhyChooseUs";
import Subsribe from "../../components/newsletter/Subsribe";
import Footer from "../../components/layout/footer/Footer";

export default function Home() {
  return (
    <Layout>
      <Navbar darkBg />
      <Hero />
      <WhyParticipate />
      <WhyChooseUs />
      {/* <Subsribe /> */}
      <Footer space />
    </Layout>
  );
}
